import { render, staticRenderFns } from "./StatusIconYandex.vue?vue&type=template&id=03b2a77c&scoped=true&"
import script from "./StatusIconYandex.vue?vue&type=script&lang=js&"
export * from "./StatusIconYandex.vue?vue&type=script&lang=js&"
import style0 from "./StatusIconYandex.vue?vue&type=style&index=0&id=03b2a77c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03b2a77c",
  null
  
)

export default component.exports